<div class="container text-center password-reset-container">
  <div class="password-reset-container-overlay"></div>
  <div class="card success-card">
    <h1>Enter and confirm the new password</h1>
    <form #pf="ngForm" [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <input type="password"
               id="password"
               class="form-control"
               formControlName="password"
               [disabled]="pf.submitted && isSuccessful">
      </div>
      <div class="form-group">
        <input type="password"
               id="password-confirm"
               class="form-control"
               formControlName="passwordConfirm"
               [disabled]="pf.submitted && isSuccessful">
      </div>
      <button [disabled]="pf.submitted && isSuccessful" type="submit" class="btn reset-password-button">
        Save
      </button>
    </form>
    <div class="alert alert-success" *ngIf="pf.submitted && isSuccessful">
      Your password was changed successfully. You can use it for login now
    </div>
    <div class="alert alert-warning" *ngIf="pf.submitted && !isSuccessful && errorMessage">
      {{ errorMessage }}
    </div>
  </div>
</div>
